import recorderSrc from 'mixpanel-browser/dist/mixpanel-recorder.min.js?url';
import mixpanel from 'mixpanel-browser/dist/mixpanel-with-async-recorder.cjs.js';

const TOKEN = import.meta.env.VITE_APP_MIXPANEL_TOKEN;
const ENV = import.meta.env.VITE_APP_ENVIRONMENT;

const SENSITIVE_SELECTORS = [
    '.mp-mask',
    '[name="ssn"]',
    '[name="ssn_id"]',
    '[name="date_of_birth"]',
    '[name="account_number"]',
    '[name="routing_number"]',
    '[name="ein"]',
    '[name^="ein."]',
    '[name$=".ein"]',
    '[name="id_number"]',
    '[name="government_id.id_number"]',
];

let inited = false;

export const analytics = {
    load() {
        if (!TOKEN || inited) return;
        mixpanel.init(TOKEN, {
            debug: ENV !== 'production',
            persistence: 'cookie',
            cross_subdomain_cookie: true,
            track_pageview: true,
            autocapture: {
                pageview: true,
                click: true,
                submit: true,
                input: false,
                scroll: false,
                capture_text_content: false,
            },
            record_sessions_percent: ENV === 'production' ? 10 : 100,
            recorder_src: recorderSrc,
            record_mask_text_selector: SENSITIVE_SELECTORS.join(', '),
            record_block_selector: '.mp-block',
            record_idle_timeout_ms: 30 * 60 * 1000,
            record_min_ms: 1000,
        });
        mixpanel.register({ env: ENV });
        inited = true;
    },
    identify(userId: string | undefined) {
        if (!inited || !userId) return;
        mixpanel.identify(userId);
    },
    setUserProperties(props: Record<string, unknown>) {
        if (!inited) return;
        mixpanel.people.set(props);
    },
    reset() {
        if (!inited) return;
        mixpanel.reset();
    },
    track(event: string, props?: Record<string, unknown>) {
        if (!inited) return;
        mixpanel.track(event, props);
    },
};
